import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateOrganizationDocumentsCache,
  OrganizationDocumentsCacheEvents,
} from '@monorepo/shared/cacheRegisters/documents/organizationDocumentsCacheRegister';
import { DocumentFileResponse } from 'mapistry-shared';
import { MutationConfig, useMutation } from 'react-query';

type UseUpdateOrganizationDocumentParams = {
  config?: MutationConfig<DocumentFileResponse, Api.ErrorResponse>;
};

export const useUpdateOrganizationDocument = (
  params?: UseUpdateOrganizationDocumentParams,
) =>
  useMutation(Api.updateOrganizationDocument, {
    ...params?.config,
    onSuccess: (data, vars) => {
      const event =
        vars.document.folderId !== undefined
          ? OrganizationDocumentsCacheEvents.MOVE
          : OrganizationDocumentsCacheEvents.UPDATE;
      invalidateOrganizationDocumentsCache(event, {
        organizationId: vars.organizationId,
      });
      return params?.config?.onSuccess?.(data, vars);
    },
  });
